import { render, staticRenderFns } from "./otherAuth.vue?vue&type=template&id=f3854e38&scoped=true&"
import script from "./otherAuth.vue?vue&type=script&lang=js&"
export * from "./otherAuth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3854e38",
  null
  
)

export default component.exports